export default __webpack_public_path__ + "aba2727b3f121a61113d2ace6ccbd8a6.png";